/**
 * contiene la información para el manejo de epp.
 */
export const defaultEpp = () => {
    return {
        id_producto: 0,
        id_epp:'',
        tipo:'',
        descripcion:'',
        ocular:[],
        proteccion_ocular:[],
        cutanea:[],
        proteccion_cutanea:[],
        respiratoria:[],
        proteccion_respiratoria:[],
        calzado:[],
        proteccion_calzado:[],
        ropa:[],
        proteccion_ropa:[],
        ocular_descrito:'',
        cutaneo_descrito:'',
        respiratorio_descrito:'',
        calzado_descrito:'',
        ropa_descrito:'',
        lista:[],
        bocular: false,
        bcutanea: false,
        brespiratoria: false,
        bcalzado: false,
        bropa: false,
        data:[],
        activo:1,
        selectedEppOcular: [],
        selectedEppRespiratoria: [],
        selectedEppTraje: [],
        selectedEppCutanea: [],
        selectedEppCalzado: []
    }
}

export const defaultFiltro = () => {
    return {
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'ASC',
        total: 0,
        buscarDescripcion: '',
        buscarTipo: ''
    }
}

export const defaultEppIcos = () => {
    return {
        layer_ocular: {},
        layer_respiratoria: {},
        layer_ropa: {},
        layer_cutanea:{},
        layer_calzado:{},
    }
}

export const dataInitialEpps = () => {
    return {
        "Protección Ocular": [],
        "Protección Cutánea": [],
        "Protección Respiratoria": [],
        "Botas/Calzado": [],
        "Traje/Ropa Protectora": []
    };
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    filtro: defaultFiltro(),
    selectedEpp: defaultEpp(),
    selectedEppIcos: defaultEppIcos(),
    iconos:[],
    ocular_pics:[
        'img/Epps/Ocular_1.jpg',
        'img/Epps/Ocular_2.jpg',
        'img/Epps/Ocular_3.jpg'                                
    ],
    guantes_pics:[
        'img/Epps/Guantes.jpg'
    ],
    respiratoria_pics:[
        'img/Epps/Respiratorio_1.jpg',
        'img/Epps/Respiratorio_2.jpg',
        'img/Epps/Respiratorio_3.jpg',
        'img/Epps/Respiratorio_4.jpg'
    ],
    botas_pics:[
        'img/Epps/Calzado.jpg'
    ],
    trajes_pics:[
        'img/Epps/Traje_1.jpg',
        'img/Epps/Traje_2.jpg'
    ],
    lista_ocular:[],
    lista_cutanea:[],
    lista_respiratoria:[],
    lista_calzado:[],
    lista_ropa:[],
    tipos_epp_modal:[],
    mensajeEliminado:false,
    // Epps cargados con IA
    eppsReadFdsIA: dataInitialEpps()
}